export enum DropDownParentViewTypes {
  grid = 0,
  card = 1,
}
